import React from 'react';
import { toast } from 'react-toastify';
import { API } from 'aws-amplify';

import reducer from './reducer';

const initialState = {
    headers: [],
    list: [],
    isFetching: true,
};

const useInvoicingHistory = (uniqueId, termId) => {
    const [scholarshipState, scholarshipDispatch] = React.useReducer(reducer, initialState);
    const [tuitionState, tuitionDispatch] = React.useReducer(reducer, initialState);
    const [invoicesState, invoicesDispatch] = React.useReducer(reducer, initialState);
    const [isInitialized, setIsInititalized] = React.useState(false);

    const [isAdjustmentOpen, setIsAdjustmentOpen] = React.useState(false);
    const [adjustmentData, setAdjustmentData] = React.useState({});

    const [studentName, setStudentName] = React.useState('');

    const [doingAjax, setDoingAjax] = React.useState(true);

    const mapData = ({ scholarship, tuition, invoice }) => {
        scholarshipDispatch({
            type: 'update',
            newState: {
                ...scholarship,
                isFetching: false,
            },
        });

        tuitionDispatch({
            type: 'update',
            newState: {
                tuitionInformation: tuition?.sections?.map((section) => {
                    return {
                        ...section,
                        isFetching: false,
                    };
                }),
            },
        });

        invoicesDispatch({
            type: 'update',
            newState: {
                ...invoice,
                isFetching: false,
            },
        });
    };

    const retrieveFinancialData = async () => {
        setDoingAjax(true);

        try {
            if (!isInitialized) {
                var { studentName: _studentName } = await API.post('ShipyardAPI', '/finances/overview/student_data', {
                    body: {
                        uniqueId,
                        termId: parseInt(termId),
                    },
                });
            }

            var data = await API.post('ShipyardAPI', '/finances/overview', {
                body: {
                    TermID: parseInt(termId),
                    UniqueID: uniqueId,
                },
            });
        } catch (e) {
            toast.error('API failure. Refresh the page or try again later.');
            return;
        }

        try {
            if (!isInitialized) {
                setStudentName(_studentName);
            }

            mapData(data);

            setIsInititalized(true);
        } catch (e) {
            toast.error('UI failure. Data has errors.');
        } finally {
            setDoingAjax(false);
        }
    };

    const toggleAdjustmentWindow = (row, reload) => {
        if (!isAdjustmentOpen) {
            setAdjustmentData(row);
        }
        setIsAdjustmentOpen((prev) => !prev);

        if (reload) retrieveFinancialData();
    };

    return {
        isInitialized,
        doingAjax,
        scholarshipInfoHeaders: scholarshipState?.headers || [],
        scholarshipData: scholarshipState?.list || [],
        tuitionInformation: tuitionState?.tuitionInformation || [],
        invoicesHeaders: invoicesState?.headers || [],
        invoicesList: invoicesState?.list || [],
        isAdjustmentOpen,
        adjustmentData,
        studentName,
        retrieveFinancialData,
        toggleAdjustmentWindow,
    };
};

export default useInvoicingHistory;
